import React from "react";
import ro from "/src/content/ro.json";

const PoliticaConfidentialitate = () => {
  const content = ro.legal.privacy;

  return (
    <div
      className="max-w-4xl mx-auto px-6 py-12 space-y-6"
      style={{ color: "var(--color-text)", backgroundColor: "var(--color-bg)" }}
    >
      <h1 className="text-3xl font-bold text-orange-500 mb-2">
        {content.title}
      </h1>
      <p className="text-sm opacity-80">{content.updatedAt}</p>

      <p>{content.intro}</p>

      <h2 className="text-xl font-semibold">{content.section1.title}</h2>
      <div>
        <p>{content.section1.operator}</p>
        <p>
          {content.section1.emailLabel}{" "}
          <a
            href={`mailto:${content.section1.email}`}
            className="text-orange-500 underline"
          >
            {content.section1.email}
          </a>
        </p>
        <p>{content.section1.sediu}</p>
      </div>

      <h2 className="text-xl font-semibold">{content.section2.title}</h2>
      <p>{content.section2.intro}</p>

      {content.section2.items.map((item) => (
        <React.Fragment key={item.label}>
          <p className="font-semibold">{item.label}</p>
          <p>{item.text}</p>
        </React.Fragment>
      ))}

      <p>{content.section2.note}</p>

      <h2 className="text-xl font-semibold">{content.section3.title}</h2>
      <p>{content.section3.intro}</p>
      <ul className="list-disc pl-6 space-y-1">
        {content.section3.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>

      <h2 className="text-xl font-semibold">{content.section4.title}</h2>
      <p>{content.section4.intro}</p>
      <ul className="list-disc pl-6 space-y-1">
        {content.section4.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <p>{content.section4.note}</p>

      <h2 className="text-xl font-semibold">{content.section5.title}</h2>
      <p>{content.section5.p1}</p>
      <p>{content.section5.p2}</p>

      <h2 className="text-xl font-semibold">{content.section6.title}</h2>
      <p>{content.section6.intro}</p>
      <ul className="list-disc pl-6 space-y-1">
        {content.section6.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <p>{content.section6.note}</p>

      <h2 className="text-xl font-semibold">{content.section7.title}</h2>
      <p>{content.section7.intro}</p>
      <ul className="list-disc pl-6 space-y-1">
        {content.section7.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <p>{content.section7.note}</p>

      <h2 className="text-xl font-semibold">{content.section8.title}</h2>
      <p>{content.section8.text}</p>

      <h2 className="text-xl font-semibold">{content.section9.title}</h2>
      <p>
        {content.section9.text}
        <br />
        {content.section9.linkPath}
      </p>

      <h2 className="text-xl font-semibold">{content.section10.title}</h2>
      <p>{content.section10.intro}</p>
      <ul className="list-disc pl-6 space-y-1">
        {content.section10.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <p>{content.section10.note}</p>

      <h2 className="text-xl font-semibold">{content.section11.title}</h2>
      <p>{content.section11.p1}</p>
      <p>{content.section11.p2}</p>

      <h2 className="text-xl font-semibold">{content.section12.title}</h2>
      <p>{content.section12.intro}</p>
      <ul className="list-disc pl-6 space-y-1">
        {content.section12.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <p>
        {content.section12.note}
        <br />
        {content.section12.linkNote}
      </p>

      <h2 className="text-xl font-semibold">{content.section13.title}</h2>
      <p>{content.section13.p1}</p>
      <p>{content.section13.p2}</p>
      <p>
        {content.section13.p3}{" "}
        <a
          href="https://www.dataprotection.ro"
          target="_blank"
          rel="noreferrer"
          className="underline"
        >
          {content.section13.websiteLabel}
        </a>
      </p>

      <h2 className="text-xl font-semibold">{content.section14.title}</h2>
      <p>{content.section14.text}</p>
    </div>
  );
};

export default PoliticaConfidentialitate;
